import { render } from "./CuentaBancoTables.vue?vue&type=template&id=55cee81f"
import script from "./CuentaBancoTables.vue?vue&type=script&lang=js"
export * from "./CuentaBancoTables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__